// Admin panel sections, shared by the sidebar and the page title in the top bar
export default [
  { to: "/admin/dashboard", label: "Dashboard", icon: "fa-chart-line" },
  { to: "/admin/newspaper", label: "E-Newspaper", icon: "fa-newspaper" },
  { to: "/admin/magazine", label: "E-Magazine", icon: "fa-book-open" },
  { to: "/admin/users", label: "Users", icon: "fa-users" },
  { to: "/admin/editorials", label: "Editorials", icon: "fa-pen-nib" },
  { to: "/admin/artist", label: "Artists", icon: "fa-palette" },
  { to: "/admin/contact", label: "Contact Messages", icon: "fa-envelope" },
  { to: "/admin/advertisements", label: "Advertisements", icon: "fa-bullhorn" },
  { to: "/admin/suggestions", label: "Suggestions", icon: "fa-comment-dots" },
];
